import {
  ActualReturnSearch,
  ActualReturnSearchResult,
  ActualReturnSummaryResult,
  TrackingIdResponse,
  GetMissingTrackingData
} from "@/types/ActualReturn";
import { marketPlaceBaseQueryWrapper } from "@/utils/rtkHelper";
import { createApi } from "@reduxjs/toolkit/query/react";

export const ActualReturnApi = createApi({
  reducerPath: "ActualReturnApi",
  baseQuery: marketPlaceBaseQueryWrapper,
  tagTypes: ["actualReturn"],
  keepUnusedDataFor: 0,
  endpoints: (builder) => ({
    getActualReturn: builder.query({
      query: () => `/actual-return-status`,
      providesTags: ["actualReturn"],
    }),
    uploadActualReturnFile: builder.mutation({
      query: ({ formData }) => ({
        url: `/document/actual-return-status/xlsx`,
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["actualReturn"],
    }),
    searchActualReturn: builder.query<
      ActualReturnSearchResult,
      ActualReturnSearch
    >({
      query: (input) => ({
        url: `/actual-return-status/search`,
        method: "POST",
        body: { ...input, export: false },
      }),
      providesTags: ["actualReturn"],
    }),
    exportActualReturn: builder.mutation<Blob, ActualReturnSearch>({
      query: (input) => ({
        url: `/actual-return-status/search`,
        method: "POST",
        body: { ...input, export: true },
        responseHandler: (response: Response) => response.blob(),
      }),
    }),
    summaryActualReturn: builder.query<
      ActualReturnSummaryResult,
      ActualReturnSearch
    >({
      query: (input) => ({
        url: `/actual-return-status/summary`,
        method: "POST",
        body: input,
      }),
      providesTags: ["actualReturn"],
    }),
    deleteActualReturns: builder.mutation<void, string[]>({
      query: (ids) => ({
        url: "/actual-return-status/delete",
        method: "DELETE",
        body: { ids },
      }),
      invalidatesTags: ["actualReturn"],
    }),
    getTrackingIdData: builder.query<TrackingIdResponse, void>({
      query: () => ({
        url: `/actual-return-status/get/tracking-id`,
        method: "GET",
      }),
    }),
    addManualReturnStatus: builder.mutation<void, any>({
      query: (input) => ({
        url: `/actual-return-status/create/actual_return`,
        method: "POST",
        body: input,
      }),
      invalidatesTags: ["actualReturn"],
    }),
    getMissingData: builder.query<GetMissingTrackingData, void>({
      query: () => ({
        url: `/actual-return-status/actual-return/missing`,
        method: "GET",
      }),
    }),

  }),
});

export const {
  useSearchActualReturnQuery,
  useLazySearchActualReturnQuery,
  useExportActualReturnMutation,
  useUploadActualReturnFileMutation,
  useGetActualReturnQuery,
  useSummaryActualReturnQuery,
  useDeleteActualReturnsMutation,
  useLazyGetTrackingIdDataQuery,
  useAddManualReturnStatusMutation,
  useLazyGetMissingDataQuery
} = ActualReturnApi;
